//@ts-check
import { MEMBER_STATUS } from "./dataTypes";

export const memberStatusStyleMapper = (status: string): string => {
  switch (status) {
    case MEMBER_STATUS.ACTIVE:
      return "active";
    case MEMBER_STATUS.INACTIVE:
      return "inactive";
    case MEMBER_STATUS.DEACTIVATED:
      return "inactive";
    case MEMBER_STATUS.INVITE_EXPIRED:
      return "expired";
    case MEMBER_STATUS.INVITE_SENT:
      return "sent";
    case MEMBER_STATUS.INVITE_NOT_SENT:
      return "inactive";
  }
};
